import React from 'react';

const SUPPORT_EMAIL = 'ozayermatubber59@gmail.com';

export default function PrivacyPage() {
  return (
    <main className="min-h-screen bg-app-background px-5 py-10 text-stone-700">
      <article className="mx-auto max-w-3xl rounded-2xl border border-stone-200 bg-white p-6 shadow-sm sm:p-10">
        <a href="/supporto" className="mb-8 inline-flex">
          <img
            src="/brand/restaurantos-logo-horizontal.svg"
            alt="RestaurantOS"
            className="h-10 w-auto"
          />
        </a>
        <h1 className="font-display text-3xl font-bold tracking-tight text-brand-navy">
          Informativa sulla privacy
        </h1>
        <p className="mt-4 leading-relaxed">
          RestaurantOS è uno strumento per la gestione del personale, dei turni,
          delle ferie, delle presenze e dei controlli HACCP. Questa pagina
          descrive le categorie di dati trattate dalle funzioni presenti
          nell’applicazione.
        </p>

        <section className="mt-8">
          <h2 className="text-lg font-semibold text-brand-navy">Chi gestisce i dati</h2>
          <p className="mt-2 leading-relaxed">
            L’azienda che ti ha dato accesso a RestaurantOS inserisce e gestisce
            i dati relativi al rapporto di lavoro e decide quali persone
            autorizzate possono consultarli. Per informazioni o richieste
            riguardanti questi dati, rivolgiti all’azienda o al suo
            amministratore. RestaurantOS fornisce la piattaforma e i servizi
            tecnici necessari al suo funzionamento.
          </p>
          <p className="mt-2 leading-relaxed">
            Per richieste relative all’account o al servizio puoi contattare
            l’assistenza all’indirizzo{' '}
            <a className="font-semibold text-brand-green underline" href={`mailto:${SUPPORT_EMAIL}`}>
              {SUPPORT_EMAIL}
            </a>.
          </p>
        </section>

        <section className="mt-8">
          <h2 className="text-lg font-semibold text-brand-navy">Dati trattati e finalità</h2>
          <ul className="mt-2 list-disc space-y-2 pl-5 leading-relaxed">
            <li>
              Dati dell’account e di contatto, come email, nome, ruolo e
              identificativi, per autenticazione e gestione degli accessi.
            </li>
            <li>
              Dati del personale e dell’organizzazione, come recapiti,
              assegnazioni, mansioni e informazioni contrattuali.
            </li>
            <li>
              Turni, richieste e saldi ferie, presenze, orari, punti di
              timbratura e verifiche, per le funzioni operative e i relativi
              controlli.
            </li>
            <li>
              Documenti caricati dall’azienda o dal dipendente, che possono
              includere contratti, documenti identificativi, documenti
              retributivi o certificati.
            </li>
            <li>
              Dati HACCP, incluse letture di temperatura, attrezzature,
              operatore, locale, esito e registrazioni di audit.
            </li>
            <li>
              Dati tecnici e di sicurezza, come identificativi di account e
              installazione, registri delle operazioni e, per alcune azioni,
              indirizzo IP.
            </li>
          </ul>
        </section>

        <section className="mt-8">
          <h2 className="text-lg font-semibold text-brand-navy">Documenti e fotografie</h2>
          <p className="mt-2 leading-relaxed">
            I documenti e le evidenze fotografiche sono conservati in archivi
            privati e accessibili secondo ruolo e ambito aziendale. La foto
            dei controlli Temperature è facoltativa; il controllo può essere
            registrato anche senza immagine. Le fotografie originali possono
            contenere metadati incorporati dal dispositivo. Alcuni flussi di
            abbattimento elaborano le immagini per proporre una lettura OCR;
            la conferma resta soggetta ai controlli previsti dal flusso.
          </p>
        </section>

        <section className="mt-8">
          <h2 className="text-lg font-semibold text-brand-navy">Servizi tecnici</h2>
          <p className="mt-2 leading-relaxed">
            Per fornire le funzioni, il servizio utilizza componenti di
            autenticazione, database, archiviazione privata e hosting, oltre
            a un servizio di invio delle email di invito e recupero password.
            Le funzioni native Apple App Attest e Core NFC sono usate per
            verifiche di sicurezza e operazioni NFC. Nel codice esaminato non
            sono presenti SDK pubblicitari o di analytics e i dati non sono
            usati per il tracciamento pubblicitario.
          </p>
          <p className="mt-2 leading-relaxed">
            Le regioni dei data center, gli eventuali trasferimenti
            internazionali e i relativi accordi dipendono dai fornitori e
            dalla configurazione del servizio; non sono determinabili dal
            solo codice dell’app.
          </p>
        </section>

        <section className="mt-8">
          <h2 className="text-lg font-semibold text-brand-navy">Conservazione e diritti</h2>
          <p className="mt-2 leading-relaxed">
            L’applicazione non definisce un unico periodo di conservazione
            valido per tutti i tenant. La durata dei dati di lavoro e dei
            documenti dipende dall’azienda che utilizza il servizio e dalle
            regole applicabili. Per conoscere i tempi previsti per i tuoi
            dati, chiedi all’azienda o al suo amministratore.
          </p>
          <p className="mt-2 leading-relaxed">
            Puoi rivolgerti all’azienda per le richieste sui dati del rapporto
            di lavoro e all’assistenza RestaurantOS per quelle relative
            all’account o al servizio. La cancellazione autonoma dell’account
            non è disponibile nell’app.
          </p>
        </section>

        <p className="mt-10 border-t border-stone-100 pt-5 text-sm text-stone-500">
          Per informazioni sull’assistenza, visita <a className="font-semibold text-brand-green underline" href="/supporto">/supporto</a>.
        </p>
      </article>
    </main>
  );
}
